// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__1sl9Y","hoverAnimation":"styles_hoverAnimation__1OT-T"};